<!--  采购申请页面  -->
<template>
  <div class="content-wrapper">
    <!-- Content Header (Page header) -->
    <section class="content-header">
      <h1>
        采购申请
        <small>采购申请</small>
      </h1>
      <ol class="breadcrumb">
        <li>
          <a href="#">
            <i class="fa fa-dashboard"></i> 采购申请
          </a>
        </li>
        <li class="active">采购申请</li>
      </ol>
    </section>
    <!-- Main content -->
    <section class="content">
      <div class="col-sm-12">
        <div id="atptoolbar"></div>

        <!--  申请表单  -->
        <div class="apply-form">
          <!-- modal-body-->
          <div class="modal-body">

            <div class="panel-body">

              <div class="form-group">
                <label class="control-label col-xs-12 col-sm-6 no-padding-right"
                       for="predictTime">预计日期:
                  <input
                    id="predictTime"
                    name="predictTime"
                    type="text"
                    class="form-control field"
                    @click="datePicker('predictTime')"
                  />
                </label>
                <label class="control-sidebar-subheading col-sm-6">
                  名称
                  <input type="text" class="form-control" v-model="form.name" placeholder="请输入名称"/>
                </label>
              </div>

              <div class="form-group">
                <label class="control-sidebar-subheading col-sm-6">
                  规格
                  <input type="text" class="form-control" v-model="form.spec" placeholder="请输入规格"/>
                </label>
                <label class="control-sidebar-subheading col-sm-6">
                  单位
                  <input type="text" class="form-control" v-model="form.unit" placeholder="请输入单位"/>
                </label>
              </div>

              <div class="form-group">
                <label class="control-sidebar-subheading col-sm-6">
                  数量
                  <input type="number" class="form-control" v-model="form.num" placeholder="请输入数量"/>
                </label>
                <label class="control-sidebar-subheading col-sm-6">
                  金额
                  <input type="number" class="form-control" v-model="form.total" placeholder="请输入金额"/>
                </label>
              </div>

              <div class="form-group">
                <label class="control-sidebar-subheading col-sm-6">
                  备注
                  <input type="text" class="form-control" v-model="form.remark"
                         placeholder=""/>
                </label>
              </div>

            </div>

          </div>
          <!-- modal-footer -->
          <div class="modal-footer">
            <button type="button" data-dismiss="modal" class="btn btn-default">关闭</button>
            <button type="button" class="btn btn-primary" @click="submit">确定</button>
          </div>
        </div>

      </div>
    </section>
  </div>
</template>

<script>

  import {datepicker} from 'eonasdan-bootstrap-datetimepicker'

  export default {
    name: 'applyProcurement',
    data() {
      return {
        form: {
          predictTime: '', // 预计日期
          name: '', // 名称
          spec: '', // 规格
          unit: '', // 单位
          num: '', // 数量
          total: '', // 金额
          remark: '', // 备注
        }
      }
    },

    components: {datepicker},

    mounted: function () {
    },

    methods: {
      submit: function () { // 发起采购申请
        let self = this
        const company = localStorage.getItem('companyInfo')
        console.log(self.form)
        if (!self.form.predictTime || !self.form.name || !self.form.spec || !self.form.unit || !self.form.num ||
          !self.form.total) {
          alert('请将申请单填写完毕')
          return
        }
        const formData = {
          '公司ID': JSON.parse(company).id,
          '预计日期': self.form.predictTime,
          '名称': self.form.name,
          '规格': self.form.spec,
          '单位': self.form.unit,
          '数量': self.form.num,
          '金额': self.form.total,
          '备注': self.form.remark,
        }
        self.global.axiosPost(self, 'apply/4/', formData, function (res) {
          console.log('/apply/4/', res)
          if (res.status === 'success') {
            alert('提交成功')
          }
        })
      },

      datePicker: function (elementId) {
        let self = this
        WdatePicker({
          el: elementId,
          dateFmt: 'yyyy-MM-dd HH:mm:ss', //日期格式，可以只显示年或年月，也可以额外显示时间
          onpicked: function () {
            var value = $('#' + elementId).val()
            console.log('___日期elementId', elementId, value)
            // var timeStamp = self.global.timeToStamp(value)
            self.form[elementId] = value
          },
          oncleared: function () {
            self[elementId] = null
          },
          isShowClear: true,
          readOnly: true
        })
      },

    }

  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/applyWorkflow/applyProcurement.vue